// React utils
import { Fragment, useEffect, useRef, useState } from 'react';
import { Zoom } from 'react-awesome-reveal';
import ScrollContainer from 'react-indiana-drag-scroll';
import { Link } from 'react-router-dom';
import ReactDOM from 'react-dom';

// Icons
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import JuntsButton from 'modules/website/shared/components/JuntsButton';
import classNames from 'classnames';

// Services
import { getSectorials } from 'api/services/wp';

// Utils
import { depureString } from 'utils/formatString';

// Scss
import './SectorialSelector.scss';

function SectorialSelector() {
  const [sectorials, setSectorials] = useState(null);
  const [selected, setSelected] = useState(null);
  const [index, setIndex] = useState(0);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [screenWidth, setScreenWidth] = useState(getScreenSize());

  const scrollContainer = useRef(null);
  const cardContainer = useRef(null);

  useEffect(() => {
    window.addEventListener('resize', handleResizeScrenWidth);

    return () => {
      window.removeEventListener('resize', handleResizeScrenWidth);
    };
  }, []);

  useEffect(() => {
    getSectorials().then(({ data }) => {
      console.log(data);
      const fetched = data[0].acf.sectorial;
      setSectorials(fetched);
      setSelected(fetched[0]);
    });
  }, []);

  useEffect(() => {
    if (sectorials) {
      setSelected(sectorials[index]);
      setScrollPosition(index * 140);
    }
  }, [index]);

  useEffect(() => {
    if (scrollContainer.current) {
      ReactDOM.findDOMNode(scrollContainer.current).scrollTo({
        behavior: 'smooth',
        left: scrollPosition,
        top: 0,
      });
    }
  }, [scrollContainer, scrollPosition]);

  function handleSelector(event, action) {
    if (!action && event) {
      setIndex(
        sectorials.indexOf(sectorials.filter((e) => e.titol === event.target.textContent)[0])
      );
    }

    if (action) {
      if (action === 'next') {
        if (index === sectorials.length - 1) {
          setIndex(0);
        } else {
          setIndex(index + 1);
        }
      }

      if (action === 'back') {
        if (index === 0) {
          setIndex(sectorials.length - 1);
        } else {
          setIndex(index - 1);
        }
      }
    }
  }

  function getScreenSize() {
    return window.innerWidth - 200;
  }

  function handleResizeScrenWidth() {
    setScreenWidth(getScreenSize());
  }

  return (
    <div className="sectorialselector__container">
      {sectorials && (
        <>
          <div className="sectorialselector__icons">
            <ArrowBackIosIcon className="arrow__icon" onClick={(e) => handleSelector(e, 'back')} />
            <ScrollContainer
              className="scroll-container"
              hideScrollbars="false"
              ref={scrollContainer}
            >
              <div className="sectorialselector__shadow">
                <div className="sectorialselector__features" style={{ width: screenWidth }}>
                  {sectorials &&
                    sectorials.map((sectorial) => (
                      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                      <div
                        ref={cardContainer}
                        className={classNames('sectorialselector__features--item', {
                          'sectorialselector__features--item-active':
                            selected.titol === sectorial.titol,
                        })}
                        key={sectorial.titol}
                        onClick={(e) => handleSelector(e)}
                        onKeyDown={(e) => handleSelector(e)}
                      >
                        {selected.titol === sectorial.titol ? (
                          <>
                            <Zoom>
                              {/* <e.icon className="sectorialselector__features--item--icon" /> */}
                              <Link
                                to={`/politiques-sectorials/${depureString(
                                  selected.titol
                                ).toLowerCase()}`}
                              >
                                <img
                                  src={sectorial.icona}
                                  className="sectorialselector__features--item--icon"
                                  alt="icona"
                                />
                              </Link>
                            </Zoom>
                            <ArrowDropDownIcon className="down__icon" />
                          </>
                        ) : (
                          <h2 className="noselect">{sectorial.titol}</h2>
                        )}
                      </div>
                    ))}
                </div>
              </div>
            </ScrollContainer>

            <ArrowForwardIosIcon
              className="arrow__icon"
              onClick={(e) => handleSelector(e, 'next')}
            />
          </div>

          <div className="sectorialselector__selected">
            {selected && (
              <Link to={`/politiques-sectorials/${depureString(selected.titol).toLowerCase()}`}>
                <div className="sectorialselector__selected--title">
                  <h2>{selected.titol}</h2>
                </div>
                <div className="sectorialselector__selected--description">
                  <p>{selected.descripcio_curta}</p>
                </div>
                <div className="sectorialselector__selected--button">
                  <JuntsButton>
                    Visita la pàgina de la sectorial <ArrowForwardIcon />
                  </JuntsButton>
                </div>
              </Link>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default SectorialSelector;
